import {
  initializeApp, getApps,
} from 'firebase/app';
import { getMessaging } from 'firebase/messaging';

export const vpdkey = 'BIDn_Beers-YbIpXjT2KmprCbhu3M8S9CNMESpKCMEl_qBrBsRPrVr8EiVzjzHfZDlm2DhW0hohlziQMY3i_6ok';

export const initFirebase = (): void => {
  if (window.location.protocol === 'https:' && 'serviceWorker' in navigator) {
    const firebaseConfigs = {
      apiKey: 'AIzaSyA14gkByCAk0IqbIjqE59fyGim9tlW048M',
      authDomain: 'coopercitrus-51f4c.firebaseapp.com',
      databaseURL: 'https://coopercitrus-51f4c.firebaseio.com',
      projectId: 'coopercitrus-51f4c',
      storageBucket: 'coopercitrus-51f4c.appspot.com',
      messagingSenderId: '938417769965',
      appId: '1:938417769965:web:91dd1db253bed4b8b4abe4',
      measurementId: 'G-N5TEJRYGRR',
    };

    let initializedFirebaseApp;
    const allFirebaseApps = getApps();

    if (!allFirebaseApps.length) {
      initializedFirebaseApp = initializeApp(firebaseConfigs);
      getMessaging(initializedFirebaseApp);
    }
  }
};
